import React from 'react';
import Image from 'next/image';

interface PropTypes {
    height?:number;
    width?:number;
    src?:string;
}

const AedLogo = ({height,width,src}:PropTypes) => {
    
  return (
      <>
          <span className="aed_logo px-1">
              <Image
                  src={src || `https://mms-delivery.sitecorecloud.io/api/media/v2/delivery/545ff802-4b88-4b4b-1933-08dc23ac2ebb/766ebc41eb0f4d378d7ff64adefdbdbb`}
                  alt="Aed_Logo"
                  width={width}
                  height={height}
              />
          </span>
      </>
  )
};

export default AedLogo;
